
import Vue from "vue"
import type { UserNavLink } from "@/utils/user-nav"

export default Vue.extend({
  props: {
    tabs: { type: Array as VuePropType<UserNavLink[]>, required: true },
    disabled: { type: Boolean, default: false },
  },

  data: () => ({
    isStart: true,
    isEnd: true,
  }),

  watch: {
    tabs: {
      handler (tabs: UserNavLink[]) {
        const markedTabIdx = tabs.findIndex(t => t.marked)
        if (markedTabIdx < 0)
          return

        const markedTabEl =
          (this.$refs.tabsRef as HTMLDivElement)?.children[markedTabIdx]
        if (!markedTabEl)
          return

        markedTabEl.scrollIntoView({
          block: "nearest",
          inline: "center",
          behavior: "auto",
        })
      },
      deep: true,
    },
  },

  mounted () {
    this.scrollToTab()

    this.onScroll()
  },

  methods: {
    tabTo (path: string) {
      const to = this.localePath(path)

      return to === this.$route.path
        ? { path: to, query: this.$route.query }
        : to
    },

    scrollToTab () {
      const el = this.$refs.tabsRef as HTMLDivElement
      if (!el) return

      const activeLink = el.querySelector(".nuxt-link-active")
      if (!activeLink) return

      activeLink.scrollIntoView({
        block: "nearest",
        inline: "center",
        behavior: "auto",
      })
    },

    onScroll () {
      const el = this.$refs.tabsRef as HTMLDivElement
      if (!el) return

      this.isStart = el.scrollLeft === 0

      this.isEnd = Math.abs(
        el.scrollLeft - (el.scrollWidth - el.clientWidth),
      ) < 1
    },

    slide (dir: -1 | 1) {
      const el = this.$refs.tabsRef as HTMLDivElement
      if (!el) return

      el.scrollBy({
        behavior: "smooth",
        left: (el.clientWidth / 2) * dir,
      })
    },
  },
})
